import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import DataTable from '../data-table/data-table';
import Modal from '../modal/modal';
import './admins.css';
import { deleteAdmin, createAdmin, fetchAdmins } from './admins.actions';
import { fetchSomeUsers } from '../users/users.actions';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import Loader from '../loader-component/loader';

class Admins extends React.Component {

    state = {
        showAddModal: false,
    };

    componentDidMount() {
        this.props.fetchAdmins();
    }

    render() {
        const { admins, loading, users, fetchSomeUsers, createAdmin, loggedId } = this.props;
        const TableLoader = ()=> <div style={{ display: 'none' }}></div>;
        return (
            <div className='courses-container admins'>
                <Loader show={ loading ? true : false } message={'Carregando, por favor aguarde...'} />
                <div className='new-entity-btn'>
                    <button onClick={() => this.setState({ showAddModal: true })} title='Novo Administrador'>
                        <i className='fa fa-plus' />
                    </button>
                </div>
                <DataTable
                    className='courses-table admins'
                    data={admins}
                    columns={COLUMNS}
                    loading={loading}
                    loadComponent={ TableLoader }
                    exportName={`admins-${moment().toISOString()}.csv`}
                />
                {this.state.showAddModal &&
                    <NewAdminModal
                        fetchSomeUsers={fetchSomeUsers}
                        createAdmin={createAdmin}
                        loggedId={loggedId}
                        users={users}
                        onClose={() => this.setState({ showAddModal: false })}
                        onSave={(admin) => this.props.createAdmin(admin)}/>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ admins, users, login }) => ({ admins: admins.data, loading: admins.loading, users, loggedId: login.userInfo.UserId });
const mapDispatchToProps = dispatch => bindActionCreators({ createAdmin, fetchSomeUsers, fetchAdmins }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Admins);

class NewAdminModal extends React.Component {

    handleAddAdmin = ({ userId, email }) => {
        this.props.createAdmin({ adminId: userId, username: email });
        this.props.onClose();
    };

    render() {
        const { users, fetchSomeUsers, loggedId, ...props } = this.props;
        return (
            <Modal show={true} {...props}>
                <div className='new-course-modal new-admin-modal'>
                    <Loader show={ users.loading ? true : false } message={'Carregando, por favor aguarde...'} />
                    <div className='modal-header'>
                        <span>Adicionar Administrador</span>
                        <i className='fa fa-times' onClick={ this.props.onClose } title='Fechar'/>
                    </div>
                    <DataTable
                        className='new-admin-users-table'
                        data={users.some.filter(u => u.userId !== loggedId)}
                        pages={users.pages}
                        exportable={false}
                        manual
                        fetchMethod={fetchSomeUsers}
                        columns={this.COLUMNS}
                    />
                </div>
            </Modal>
        );
    }

    COLUMNS = [
        { Header: 'usuário', accessor: 'email' },
        { Header: 'Ação', Cell: row => <div className='actions-row'>
            <button title='tornar administrador' onClick={() =>
                this.handleAddAdmin(row.original)}><i className='fa fa-user-plus' /></button>
        </div> },
    ];
}

class ActionsGroup extends React.Component {

    state = {
        askConfirmation: false,
    };

    render() {
        const { loggedId, original } = this.props;
        return (
            <div className='actions-row'>
                <button disabled={loggedId === original.adminId}
                    title='Remover' onClick={() => this.setState({ askConfirmation: true })}>
                    <i className='fa fa-trash' />
                </button>
                {this.state.askConfirmation &&
                <ConfirmationModal
                    show={true}
                    onClose={() => this.setState({ askConfirmation: false })}
                    onConfirm={() => this.props.deleteAdmin(original.adminId)}
                />}
            </div>
        );
    }
}

const ActionsCell = connect(({ login }) => ({ loggedId: login.userInfo.UserId }),
    dispatch => bindActionCreators({ deleteAdmin }, dispatch))(ActionsGroup);

const COLUMNS = [
    { Header: 'Email', searchable: true, accessor: 'username' },
    { Header: 'Ações', exportable: false, Cell: props => <ActionsCell {...props}/>, sortable: false },
];



// WEBPACK FOOTER //
// ./src/components/admins/admins.js